import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "undo",
  "use": "undo-usage",
  "viewBox": "0 0 12 14",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 14\" id=\"undo\"><path d=\"M6 2.513V0L2.25 3.59 6 7.18V3.95c2.475 0 4.5 1.937 4.5 4.306 0 2.37-2.025 4.308-4.5 4.308s-4.5-1.938-4.5-4.308H0C0 11.416 2.7 14 6 14s6-2.585 6-5.744c0-3.16-2.7-5.743-6-5.743\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol